<form [formGroup]="invoiceSearchForm" (ngSubmit)="submitForm('', true)" class="search-filters">
  <!-- Row 1 -->
  <div class="filter-row">
    <div class="filter-group">
      <label class="filter-label">{{ 'invoiceSearchForm.label.purchaseOrder' | cxTranslate }}</label>
      <input type="text" class="filter-input" [placeholder]="'invoiceSearchForm.label.purchaseOrder' | cxTranslate"
        formControlName="purchaseOrderNumber">
      </div>
      <div class="filter-group">
        <label class="filter-label">{{ 'invoiceSearchForm.label.status' | cxTranslate }}</label>
        <div>
          <ng-select [items]="invoiceStatusList$  | async" [clearSearchOnAdd]="true" [closeOnSelect]="true"
            labelForId="state" [placeholder]="'invoiceSearchForm.label.status' | cxTranslate"
            clearAllText="Clear" formControlName="status" [bindLabel]="'Text'" [ngModel]="pStatus" [searchable]="false">
            <ng-template ng-option-tmp let-item="item">

              <div>
                {{item['Text']}}
              </div>

            </ng-template>
            <ng-template ng-multi-label-tmp let-items="items">
              @for (item of items | slice:0:1; track item) {
                <div class="ng-value">
                  {{item['Text']}}
                </div>
              }
              @if (items.length > 1) {
                <div class="ng-value">
                  <span class="ng-value-label">{{items.length - 1}} more...</span>
                </div>
              }
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div class="filter-group">
        <label class="filter-label">{{ 'invoiceSearchForm.label.documentType' | cxTranslate }}</label>
        <ng-select [items]="invoiceDocumentTypeList$  | async" [clearSearchOnAdd]="true" [closeOnSelect]="true"
          labelForId="state" [placeholder]="'invoiceSearchForm.label.documentType' | cxTranslate"
          clearAllText="Clear" [searchable]="false" formControlName="documentType" [bindLabel]="'Text'" [ngModel]="pDocumentType">
          <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">

            <div>

              {{item['Text']}}
            </div>

          </ng-template>
          <ng-template ng-multi-label-tmp let-items="items">
            @for (item of items | slice:0:1; track item) {
              <div class="ng-value">
                {{item['Text']}}
              </div>
            }
            @if (items.length > 1) {
              <div class="ng-value">
                <span class="ng-value-label">{{items.length - 1}} more...</span>
              </div>
            }
          </ng-template>
        </ng-select>
      </div>
      <div class="filter-group">
        <label class="filter-label">{{ 'invoiceSearchForm.label.document' | cxTranslate }}</label>
        <input type="text" class="filter-input" [placeholder]="'invoiceSearchForm.label.document' | cxTranslate"
          formControlName="documentNo">
        </div>
        @if (brandList$ | async; as brands) {
          <div class="filter-group">
            <label class="filter-label">{{ 'invoiceSearchForm.label.brand' | cxTranslate }}</label>
            <ng-select [items]="brands" [searchable]="false" [clearSearchOnAdd]="true" [closeOnSelect]="true" labelForId="state"
              [placeholder]="'invoiceSearchForm.label.brand' | cxTranslate" clearAllText="Clear" formControlName="brandName"
              [bindLabel]="'name'" [ngModel]="pBrandName">
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <div>
                  {{item['name']}}
                </div>
              </ng-template>
              <ng-template ng-multi-label-tmp let-items="items">
                @for (item of items | slice:0:1; track item) {
                  <div class="ng-value">
                    {{item['name']}}
                  </div>
                }
                @if (items.length > 1) {
                  <div class="ng-value">
                    <span class="ng-value-label">{{items.length - 1}} more...</span>
                  </div>
                }
              </ng-template>
            </ng-select>
          </div>
        }
        <div class="datepicker-wrapper">
          <label class="filter-label">{{ 'invoiceSearchForm.label.from' | cxTranslate }}</label>
          <input class="filter-input mt-1" [placeholder]="'invoiceSearchForm.label.from' | cxTranslate" name="fromDate"
            ngbDatepicker #fromDate="ngbDatepicker" formControlName="_startDate" [readonly]="true"
            [maxDate]="maxStartDate()" (dateSelect)="onDateChange($event, 'fDate')" container="body" />

            <i class="far fa-calendar-alt color-font header-icon-color calendar-icon" (click)="fromDate.toggle()"></i>


          </div>
        </div>

        <!-- Row 2 -->
        <div class="filter-row row-2">
          <div class="datepicker-wrapper">
            <label class="filter-label">{{ 'invoiceSearchForm.label.to' | cxTranslate }}</label>
            <input  class="filter-input mt-1" [placeholder]="'invoiceSearchForm.label.to' | cxTranslate" name="endDate"
              ngbDatepicker #endDate="ngbDatepicker" formControlName="_endDate" [readonly]="true" [maxDate]="maxEndDate()"
              (dateSelect)="onDateChange($event)" container="body">

              <i class="far fa-calendar-alt color-font header-icon-color calendar-icon" (click)="endDate.toggle()"></i>

            </div>
            <div class="filter-group">
              <label class="filter-label">{{ 'invoiceSearchForm.label.jobName' | cxTranslate }}</label>
              <input type="text" class="filter-input"[placeholder]="'invoiceSearchForm.label.jobName' | cxTranslate" formControlName="jobName">
            </div>
            <div class="filter-group">
              <!-- Empty for spacing -->
            </div>
            <div class="filter-group">
              <!-- Empty for spacing -->
            </div>
            <div class="filter-group">
              <!-- Empty for spacing -->
            </div>
            <div class="filter-group">
              <!-- Empty for spacing -->
            </div>
          </div>

          <!-- Search Actions -->
          <div class="search-actions">
            <button class="search-btn" [disabled]="isSearchDisabled$ | async">{{ 'button.search' | cxTranslate }}</button>
            <button class="reset-btn" (click)="resetForm()"> {{ 'button.reset' | cxTranslate }}</button>
          </div>
        </form>